import { isIndividualMoneyGoal, type Goal, type IndividualMoneyGoal } from "@/lib/schemas";

/**
 * Sortuje cele dziecka (individual_money) do wyświetlenia. Zasada:
 *
 *   1. Niezaliczone (balance < target) PRZED zaliczonymi.
 *   2. W obrębie niezaliczonych: najbliższy do osiągnięcia (najmniejszy
 *      `target - balance`) na początku — to jest "default focus".
 *   3. W obrębie zaliczonych: najnowsze pierwsze (po createdAt desc).
 *
 * Filter automatyczny — pomija family_count / family_offline_count
 * (te są mierzone w jednostkach, nie pieniądzach).
 *
 * Używane w hero ChildDashboard i ChildWallet do pokazania "aktywnego"
 * celu i kolejności swipe.
 */
export function sortGoalsByPriority(
  goals: readonly Goal[],
  balanceMinor: number,
): IndividualMoneyGoal[] {
  return goals.filter(isIndividualMoneyGoal).sort((a, b) => {
    const aDone = balanceMinor >= a.targetMinor ? 1 : 0;
    const bDone = balanceMinor >= b.targetMinor ? 1 : 0;
    if (aDone !== bDone) return aDone - bDone;
    if (aDone === 0) {
      return a.targetMinor - balanceMinor - (b.targetMinor - balanceMinor);
    }
    return b.createdAt.toMillis() - a.createdAt.toMillis();
  });
}
